import {NonWorkingDayModel} from './non-working-day.model';
import {XauditModel} from '../../xaudit.model';

export class NonWorkingYearModel {
  NonWorkingYear: number;
}

export class NonWorkingDaysModel extends XauditModel {
  cfgScheduleNonWorkingDays: NonWorkingDayModel[];
  WorkRegionID: string;
  RegionName: string;
  enumCountryID: string;

  ByYear: Map<number, NonWorkingDayModel[]> = new Map();
  YearList: NonWorkingYearModel[] = [];
  nonWorkingDayTextLabel: string = 'No Work';

  constructor(nonWorkingDays: NonWorkingDayModel[]) {
    super();
    this.cfgScheduleNonWorkingDays = nonWorkingDays;
    nonWorkingDays.forEach(o => {
      if (this.ByYear.has(o.NonWorkingYear)) {
        this.ByYear.get(o.NonWorkingYear).push(o);
      }
      else {
        this.ByYear.set(o.NonWorkingYear, [o]);
        const model = new NonWorkingYearModel();
        model.NonWorkingYear = o.NonWorkingYear;
        this.YearList.push(model);
      }
    });
  }

  getDayByDayNumber(dayNumString: string): string {
    switch (dayNumString) {
      case '0':
        return 'SU';
      case '1':
        return 'MO';
      case '2':
        return 'TU';
      case '3':
        return 'WE';
      case '4':
        return 'TH';
      case '5':
        return 'FR';
      case '6':
        return 'SA';
    }
  }

  public toScheduleDataSource(selectedYear: number): any[] {
    const toReturn: any[] = [];

    const daysForYear = this.cfgScheduleNonWorkingDays.filter(p => p.NonWorkingYear === selectedYear);

    for (const m of daysForYear)
    {
      const day = new Date(m.NonWorkingDay);
      const nextDay: Date = new Date(m.NonWorkingDay);
      nextDay.setDate(day.getDate() + 1);
      if (m.NonWorkingDay) {
        toReturn.push({
          text: this.nonWorkingDayTextLabel,
          startDate: day,
          endDate: nextDay,
          allDay: true,
          model: m
        });
      }
    }

    return toReturn;
  }

  public AddEmptyYear(): void {
    if (this.ByYear.size === 0 && this.YearList.length === 0) {
      const currYear: number = new Date().getFullYear();
      this.ByYear.set(currYear, []);
      const model = new NonWorkingYearModel();
      model.NonWorkingYear = currYear;
      this.YearList.push(model);
    } else {
      const sortedList = this.YearList.sort((a, b) => a.NonWorkingYear - b.NonWorkingYear);
      let yearToAdd: number = new Date().getFullYear();

      while (true) {
        if (sortedList.find(o => o.NonWorkingYear === yearToAdd) == null) {
          this.ByYear.set(yearToAdd, []);
          this.YearList.push(({ NonWorkingYear: yearToAdd }));
          break;
        }

        yearToAdd += 1;
      }
    }
  }
}
